import axios from "axios";

export default {

    namespaced: true,

    state: {

        userbanks: [],
        userbank: {}

    },

    getters: {

        userbanks(state) {
            return state.userbanks;
        },
        userbank(state) {
            return state.userbank;
        }

    },

    mutations: {

        SET_USER_BANKS(state, userbanks) {
            return state.userbanks = userbanks
        },

        SET_USER_BANK(state, userbank) {
            return state.userbank = userbank
        },

        ADD_USER_BANK(state, userbank) {
            // return state.userbank = userbank
            return state.userbanks.push(userbank);
        }

    },

    actions: {

        async fetchUserBanks({ commit }, params) {

            await axios.get('/api/v1/userbanks', { params: params })
                .then(res => {
                    commit('SET_USER_BANKS', res.data);
                }).catch(err => {
                    return Promise.reject(err);
                })

        },

        async fetchUserBank({ commit }, userbank_id) {

            await axios.get(`/api/v1/userbanks/${userbank_id}`)
                .then(res => {
                    if (res.statusText === 'OK') {
                        commit('SET_USER_BANK', res.data.data);
                    }
                }).catch(err => {
                    return Promise.reject(err);
                })

        },

        async createUserBank({ commit, dispatch }, userbank) {

            await axios.post('/api/v1/userbanks', userbank)
                .then(res => {
                    if (res.statusText === 'OK') {
                        // dispatch('fetchUserBanks');
                        console.log("res.data.data", res.data.data);
                        commit('ADD_USER_BANK', res.data.data);
                    }
                }).catch(err => {
                    return Promise.reject(err);
                })

        },

        async updateUserBank({ commit, dispatch }, userbank) {

            console.log("userbank ", userbank);
            await axios("/api/v1/userbanks/" + userbank.user_bank_id, {
                method: "patch",
                data: userbank,
            }).then(res => {
                if (res.statusText === 'OK') {
                    dispatch('fetchUserBanks');
                }
            }).catch(err => {
                return Promise.reject(err);
            })

        },

        async deleteUserBank({ commit }, userbank_id) {

            await axios.delete(`/api/v1/userbanks/${userbank_id}`)
                .then(res => {
                    if (res.statusText === 'OK') {
                        dispatch('fetchUserBanks');
                    }
                }).catch(err => {
                    return Promise.reject(err);
                });

        }

    }


}
